<!---左侧悬浮功能框-->
<!---该功能包含 点赞 收藏 分享--->
<template>
<div class="share-fun">
    <div class="like-cont" :class="{haved:hasThumbUp}" @click="zanChange" v-if="topic">
        <div class="like" ><i class="yk-liked"></i></div>
        <div class="like-count">{{thumbUpTotal}}</div>
    </div>
    <div class="spare-line" v-if="topic"></div>
    <div class="btn-fun collect" @click="favorite" :class="{haved:isFavorite}" v-if="topic">
        <div class="ico" ><i class="yk-collection-o"></i></div>
        <div class="txt">{{isFavorite?'已收藏':'收藏'}}</div>
    </div>
    <div class="">
        <el-popover trigger="hover" placement="left" class="share-popover">
            <div slot="reference">
               <div class="btn-fun  share">
                   <div class="ico"><i class="yk-news_share"></i></div>
                   <div class="txt">分享</div>
               </div>
            </div>

            <div class="qrcode-box">
                <canvas ref="qrCode" class="qrcode"></canvas>
                <div class="">微信扫码分享</div>
            </div>
        </el-popover>
    </div>
</div>
</template>
<script>
import QRCode from 'qrcode';
import {hostBuild} from '@/utils/utils';
export default {
    name:'LeftShare',
    props:['topic'],
    data(){
        return {
            isClick:false,
            detail:{},
        }
    },
    computed:{
        hasThumbUp(){
            return this.detail.property && this.detail.property.hasGivenThumbUp;
        },
        thumbUpTotal(){
            return this.detail.property?.thumbUpTotal||0
        },
        isFavorite(){
            return this.detail.property?.isFavorite;
        },
        account(){
            return this.$store.getters.user;
        }
    },
    created(){
        this.getCmsDetail();
    },
    mounted() {
        this.createQrcode();
   
        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', this.pageScroll);
        });
    },
    methods: {
        //点赞操作
        async zanChange(){

            if(this.hasThumbUp){
                //取消
                let result = await this.$axios.post('/cms/v1/drop/thumb/up/to/post',{id:this.detail.id});
                if( result.code == 0 ){
                    this.detail['property']['hasGivenThumbUp'] = 0;
                    this.detail.property.thumbUpTotal -=1;
                    this.$success('取消点赞成功!');
                }
            }else{
                let result = await this.$axios.post('/cms/v1/give/thumb/up/to/post',{id:this.detail.id});
                if( result.code == 0 ){
                    this.detail['property']['hasGivenThumbUp'] = 1;
                    this.detail.property.thumbUpTotal +=1;
                    this.$success('点赞成功');
                }
            }
        },
        //收藏操作
        async favorite(){
             if( this.account.id == undefined){
                window.location.href = hostBuild(`/login?redirect=${window.location.href}`, 'account');
                return false;
            }
            if( this.isFavorite){
                //取消
                let result = await this.$axios.post('/cms/v1/remove/favorite/item',{postIds:[this.detail.id]});
                if( result.code == 0 ){
                    this.detail.property.isFavorite = false;
                    this.$success('取消收藏成功!')
                }
            }else{
                let result = await this.$axios.post('/cms/v1/add/favorite/item',{postId:this.detail.id});
                if( result.code == 0 ){
                    this.detail.property.isFavorite = true;
                    this.$success('收藏成功!')
                }
            }
        },
        /**
         * 生成二维码
         */
        createQrcode() {
            QRCode.toCanvas(this.$refs.qrCode, location.href, { width: 80, margin: 0 });
        },
        /**获取专题详情 */
        async getCmsDetail(){
            if(!this.topic) return false;
            let result = await this.$axios.post('/cms/v1/get/topic/post/detail',{cmsType:5,postId:this.topic});
            
            if( result.code == 0 ){
                this.detail = result.data;
            }
        },
    },
}
</script>
<style lang="less" scoped>
.share-fun{
    position: fixed; z-index: 1000; left: 50%; margin-left: -520px; top: 150px;
}
.qrcode-box{text-align: center; padding:8px 18px;}
.qrcode{width:100px; height: 100px; margin: 0 auto 10px;}
.like-cont{
    .like{
        width: 48px; height: 48px; line-height: 48px; text-align: center; background: #fff; border-radius: 50%; font-size: 26px; margin-bottom: 5px; cursor: pointer;
        
    }
    text-align: center;
    &.haved{
        color: #e43a3a;
        .like{background: #f6e5e5;}
    }
}
.btn-fun{
    text-align: center;
    &.haved{color: #e43a3a;}
    .ico{font-size: 20px; line-height: 20px;cursor: pointer;
        
    }
    .txt{font-size: 12px; line-height: 17px;}
}
.share{margin-top: 25px;}

.spare-line{height: 1px; width: 24px; margin: 20px auto; background: #e7e7e7;}
</style>